import { Temporal } from "@js-temporal/polyfill";

export type LogicalPeriod = {
  key: string;
  startsAt: string;
  endsAt: string;
  timezone: string;
  cutoffMinutes: number;
};

function boundaryFor(
  date: Temporal.PlainDate,
  timezone: string,
  cutoffMinutes: number,
): Temporal.ZonedDateTime {
  const hour = Math.floor(cutoffMinutes / 60);
  const minute = cutoffMinutes % 60;
  return date
    .toPlainDateTime({ hour, minute })
    .toZonedDateTime(timezone, { disambiguation: "compatible" });
}

export function logicalPeriodAt(
  epochMilliseconds: number,
  timezone: string,
  cutoffMinutes: number,
): LogicalPeriod {
  const now =
    Temporal.Instant.fromEpochMilliseconds(
      epochMilliseconds,
    ).toZonedDateTimeISO(timezone);
  const todayBoundary = boundaryFor(now.toPlainDate(), timezone, cutoffMinutes);
  const logicalDate =
    Temporal.ZonedDateTime.compare(now, todayBoundary) < 0
      ? now.toPlainDate().subtract({ days: 1 })
      : now.toPlainDate();
  const start = boundaryFor(logicalDate, timezone, cutoffMinutes);
  const end = boundaryFor(
    logicalDate.add({ days: 1 }),
    timezone,
    cutoffMinutes,
  );
  return {
    key: logicalDate.toString(),
    startsAt: start.toInstant().toString(),
    endsAt: end.toInstant().toString(),
    timezone,
    cutoffMinutes,
  };
}

export function nextLogicalPeriod(period: LogicalPeriod): LogicalPeriod {
  const nextStartInstant = Temporal.Instant.from(period.endsAt);
  return logicalPeriodAt(
    Number(nextStartInstant.epochMilliseconds) + 1,
    period.timezone,
    period.cutoffMinutes,
  );
}

export function periodTitle(horizon: string, key: string): string {
  if (horizon === "today") return `Today · ${key}`;
  if (horizon === "week") return "This Week";
  if (horizon === "year") return key;
  if (horizon === "every_year") return "Every Year";
  if (horizon === "five_year") return "Next 5 Years";
  if (horizon === "ten_year") return "Next 10 Years";
  return "Life";
}
